import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';
import TextField from '@mui/material/TextField';
import { useCallback, useState } from 'react';
import { createFindPlayerOutbound } from '../../api/outbound/commonOutbounds';
import { useInstanceId } from '../../context/instance/instanceContext';
import { useSocketSend } from '../../context/webSocket/webSocketContext';
import { FormControlContainer } from '../formControlContainer';
export const FindPlayerMessageBoxContents = ({ onClose }) => {
    const instanceId = useInstanceId();
    const socketSend = useSocketSend();
    const [username, setUsername] = useState('');
    const onChangeUsername = (event) => {
        setUsername(event.target.value);
    };
    const onClickFind = useCallback(() => {
        socketSend(createFindPlayerOutbound(username));
        onClose();
    }, [socketSend, username, onClose]);
    const onKeyDown = useCallback((event) => {
        if (event.key === 'Enter') {
            onClickFind();
        }
    }, [onClickFind]);
    return (_jsxs(_Fragment, { children: [_jsx(DialogContentText, { children: "Enter at least 3 letters of the username." }), _jsx(FormControlContainer, { children: _jsx(TextField, { id: `find-username-${instanceId}`, variant: 'filled', fullWidth: true, label: 'Username', value: username, onChange: onChangeUsername, onKeyDown: onKeyDown, inputRef: (input) => {
                        input?.focus();
                    } }) }), _jsx(DialogActions, { children: _jsx(Button, { variant: 'contained', size: 'large', onClick: onClickFind, children: "Find" }) })] }));
};
